import React from "react";
import { StoreSearchFilters } from "tsi-common-react/src/apps/retail/models";
import { IMiles, isoMiles } from "tsi-common-react/src/models/nominals";

import { FilterChangeHandler } from "../models";
import { LocatorFilterPopover } from "./LocatorFilters_Popover";

const DISTANCE_OPTIONS = [10, 20, 30, 40, 50, 75, 100];

export const DistanceFilter = (props: {
    filterValues: StoreSearchFilters;
    onChange: FilterChangeHandler;
}): React.ReactNode => {
    const [value, setValue] = React.useState<IMiles>(
        props.filterValues.distance,
    );
    const filterElemRef = React.useRef<{
        onRequestClose: () => void;
    }>(null);

    // Sync local state with Redux state when it changes
    React.useEffect(() => {
        setValue(props.filterValues.distance);
    }, [props.filterValues.distance]);

    const handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        setValue(isoMiles.wrap(parseInt(event.currentTarget.value, 10)));
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        props.onChange({
            distance: value,
        });
        if (filterElemRef.current) {
            filterElemRef.current.onRequestClose();
        }
    };

    const handleAfterClose = () => {
        // Revert filter back to the state in Redux
        setValue(props.filterValues.distance);
    };

    return (
        <LocatorFilterPopover
            ref={filterElemRef}
            id="distance"
            // TODO(i18n): Use t with interpolation: t`${props.filterValues.distance} miles`
            labelText={`${props.filterValues.distance} miles`}
            onAfterClose={handleAfterClose}
        >
            <form
                className="filters__dropdown filters__dropdown--distance"
                onSubmit={handleSubmit}
            >
                <fieldset>
                    {/* TODO(i18n): Use t tagged template: {t`Change the distance search radius.`} */}
                    <legend className="filters__instruct">
                        Change the distance search radius.
                    </legend>
                    <div className="form__field filters__inputs">
                        <label htmlFor="bh-sl-maxdistance"></label>
                        <select
                            id="bh-sl-maxdistance"
                            className="form__select"
                            name="bh-sl-maxdistance"
                            // TODO(i18n): Use t tagged template: aria-label={t`Max Distance`}
                            aria-label="Max Distance"
                            onChange={handleChange}
                            value={isoMiles.unwrap(value)}
                        >
                            {DISTANCE_OPTIONS.map((opt) => {
                                return (
                                    <option key={opt} value={opt}>
                                        {/* TODO(i18n): Use t with interpolation: {t`${opt} miles`} */}
                                        {opt} miles
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="filters__actions sl-search__actions">
                        <input
                            className="filters__button button"
                            type="submit"
                            // TODO(i18n): Use t tagged template: aria-label={t`Submit`}
                            aria-label="Submit"
                        />
                    </div>
                </fieldset>
            </form>
        </LocatorFilterPopover>
    );
};
